import React from 'react';
import { LinkedSellingAccount } from '@models/account';
import useIntl from '@i18n/useIntl';
import AccountDetailsSellingAccount from 'src/pages/accountSettings/components/AccountDetails/AccountDetailsSellingAccount';
import { SELLING_ACCOUNT_FIELD_LABEL } from 'src/pages/accountSettings/components/AccountDetails/constants';

interface AccountDetailsSellingAccountListProps {
  sellingAccounts: LinkedSellingAccount[];
}

const AccountDetailsSellingAccountList = ({
  sellingAccounts,
}: AccountDetailsSellingAccountListProps) => {
  const { intl } = useIntl();

  const label = intl.formatMessage(SELLING_ACCOUNT_FIELD_LABEL, {
    count: sellingAccounts.length,
  });

  return (
    <>
      {sellingAccounts.map((account, index) => (
        <AccountDetailsSellingAccount
          key={account.sellingAccountLinkToken}
          sellingAccount={account}
          label={index === 0 ? label : ''} // only first selling account should be labeled
        />
      ))}
    </>
  );
};

export default AccountDetailsSellingAccountList;
